import React, {Component} from "react";
import {Link} from "react-router-dom";
import "./CaseStudy.css";

import PageSection from "PageSection/PageSection";
import Hyperlink from "Hyperlink/Hyperlink";
import Icon from "Icon/Icon";
import Header from "Header/Header";
import Logo from "Logo/Logo";
import Footer from "Footer/Footer";
import InvalidCaseStudy from "./InvalidCaseStudy/InvalidCaseStudy";

import utils from "utils";

export default class CaseStudy extends Component
{
	constructor()
	{
		super();

		this.exit = this.exit.bind(this);
	}

	exit()
	{
		this.props.history.goBack();
	}

	render()
	{
		let project = this.props.match.params.project;
		let data;

		try
		{
			data = require("cases/" + project);
		}
		catch(_)
		{
			return <InvalidCaseStudy />;
		}

		let sections = data.sections.map((section, i) =>
		{
			let color = utils.defaultValue(section.color, "white");

			return (
				<div key={i} className="section">
					{typeof(section.image) !== "undefined" &&
						<div className="image-container">
							<img src={section.image} alt={section.alt} className="image" />
						</div>
					}

					{typeof(section.title) !== "undefined" &&
						<div className="title">
							<Header
								title={section.title}
								color={color}
								marginBottom={0}
								small
							/>

							{section.link &&
								<Hyperlink href={section.link[1]} className="link" style={{color}} newTab>
									{section.link[0]}
								</Hyperlink>
							}
						</div>
					}

					{typeof(section.body) !== "undefined" &&
						<div dangerouslySetInnerHTML={{__html: section.body}} className="body" />
					}
				</div>
			);
		});

		const classes = utils.joinClasses(
		[
			"case-study-page",
			(data.slogan && "hasSlogan"),
		]);

		return (
			<div className={classes}>
				<PageSection>
					<Logo accented />

					<Link to="/">
						<div /*onClick={this.exit}*/ className="exit">
							{/*<Icon>exit</Icon>

							<div className="exit-text">Back</div>*/}

							<div className="exit-text">Back</div>
							<Icon>arrow-right</Icon>
						</div>
					</Link>

					<div className="top">
						<div className="title">
							{data.title}
						</div>

						{data.slogan &&
							<div className="slogan">
								{data.slogan}
							</div>
						}

						<Hyperlink href={data.website} className="website" newTab>
							{utils.defaultValue(data.websiteText, "Visit official website")}
						</Hyperlink>
					</div>

					<div className="content">
						{sections}
					</div>

					{/*<div className="more-container">
						<Link to="/#portfolio" className="more">
							More case studies
						</Link>
					</div>*/}
				</PageSection>

				<Footer />
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/components/CaseStudy/CaseStudy.js